
import React from 'react';
import GasPressureChart from './GasPressureChart';
import GasFlowChart from './GasFlowChart';

const GasQualityTab = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <GasPressureChart />
      <GasFlowChart />
    </div>
  );
};

export default GasQualityTab;
